var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-list"},[_vm._l((_vm.fields),function(item,index){return [_c('fe-form-group',{key:index},[_c(item.component,{tag:"component",attrs:{"fq":item},on:{"change":_vm.changeValue}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }